import { render } from "./user_profile.vue?vue&type=template&id=3c50c75c"
import script from "./user_profile.js?vue&type=script&lang=js&external"
export * from "./user_profile.js?vue&type=script&lang=js&external"

import "./user_profile.vue?vue&type=style&index=0&id=3c50c75c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__